import React, { useEffect, useRef, useContext } from 'react';
import { Link, withRouter } from "react-router-dom";
import ExternalLinks from '../../elements/ExternalLinks/';
import NousConnaitre from '../../../views/NousConnaitre';
import ShareImg from "../../../assets/img/icons/link.svg";

const { REACT_APP_PUBLIC_URL } = process.env;

const NavActions = ({ location }) => {
//	const url = location ? `${REACT_APP_PUBLIC_URL}${location.pathname}${location.hash && location.hash}` : null;
	const ref = useRef();

	useEffect(() => {
		handleHide()
	}, [])
	const handleShow = () => {
			ref.current.className = "is-flex"
	}
	const handleHide = () => {
			ref.current.className = "is-hidden"
	}

	return(

		<div className="nav-actions is-flex">
				<NousConnaitre />
				<div className="cursor_pointer ml-2" onMouseEnter={ handleShow } onMouseLeave={ handleHide } >
					<img className="mb-2" src={ ShareImg } width="40px" />
					<div ref={ ref }>
							<ExternalLinks />
					</div>
				</div>
		</div>
	);
};
export default withRouter(NavActions);
